import React, { useEffect, useState } from 'react';
import '../../Admin1/Pages/admin1.css';
import heloicon from '../../../safreeimg/superadminimg/heloicon.png';
import axios from 'axios';
import Loader from '../../../safreeimg/loader.gif';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

const GuardianCheckIn = () => {
    const [checkIns, setCheckIns] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [showForm, setShowForm] = useState(false);
    const [selectedCheckIn, setSelectedCheckIn] = useState(null);

    const rowsPerPage = 10;

    const fetchCheckIns = async () => {
        try {
            setLoading(true);
            setError(null);

            const token = localStorage.getItem('token');
            if (!token) {
                setError('No token found');
                setLoading(false);
                return;
            }

            const response = await axios.get('https://api.safree.org/api-v2022/org-guardian/my/v1/total-user-checkIn', {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            setCheckIns(response.data.data);
        } catch (err) {
            setError('Error fetching data: ' + err.message);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchCheckIns();
    }, []);

    const totalPages = Math.ceil(checkIns.length / rowsPerPage);
    const currentRows = checkIns.slice(
        (currentPage - 1) * rowsPerPage,
        currentPage * rowsPerPage
    );

    const handlePageChange = (direction) => {
        if (direction === 'prev' && currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
        if (direction === 'next' && currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const getPageNumbers = () => {
        const maxPageNumbersToShow = 5;
        const startPage = Math.max(1, currentPage - Math.floor(maxPageNumbersToShow / 2));
        const endPage = Math.min(totalPages, startPage + maxPageNumbersToShow - 1);

        const pageNumbers = [];
        for (let i = startPage; i <= endPage; i++) {
            pageNumbers.push(i);
        }
        return pageNumbers;
    };

    const handleView = (checkIn) => {
        setSelectedCheckIn(checkIn);
        setShowForm(true);
    };

    const closeForm = () => {
        setShowForm(false);
    };

    if (loading) return <div className='loading'><img src={Loader} alt="Loading..." /></div>;
    if (error) return <div>Error: {error}</div>;

    return (
        <div className="container user-management">
            <div className="row header">
                <div className="col-md-6">
                    <p className="sub-heading">CheckIn Management</p>
                </div>
            </div>

            <div className="content-wrapper">
                <div className="table-container">
                    <table className="styled-table">
                        <thead>
                            <tr>
                                <th>S.No</th>
                                <th>Name</th>
                                <th>Email</th>
                                <th>Phone</th>
                                <th>Date & Time</th>
                                <th>Description</th>
                                <th>Location</th>
                            </tr>
                        </thead>
                        <tbody>
                        {checkIns.length === 0 ? (
                                <tr>
                                    <td colSpan="10" style={{ textAlign: 'center', fontSize: '42px', color: '#f54138', fontWeight: 700 }}>No Data Found</td>
                                </tr>
                            ) : (
                            currentRows.map((checkIn, index) => (
                                <tr key={checkIn.checkInId}>
                                    <td>{(currentPage - 1) * rowsPerPage + index + 1}</td>
                                    <td>{checkIn.userName}</td>
                                    <td>{checkIn.email}</td>
                                    <td>{checkIn.phoneNumber}</td>
                                    <td>{new Date(checkIn.created).toLocaleString()}</td> {/* Date + Time */}
                                    <td>{checkIn.description}</td>
                                    <td>
                                        <button
                                            className="btn btn-view"
                                            onClick={() => handleView(checkIn)}
                                        >
                                            View
                                        </button>
                                    </td>
                                </tr>
                             ))
                            )}
                        </tbody>
                    </table>

                    <div className="pagination-container">
                        <button
                            className="pagination-btn"
                            onClick={() => handlePageChange('prev')}
                            disabled={currentPage === 1}
                        >
                            &laquo; Prev
                        </button>
                        {getPageNumbers().map((page) => (
                            <button
                                key={page}
                                className={`pagination-btn ${currentPage === page ? 'active' : ''}`}
                                onClick={() => setCurrentPage(page)}
                            >
                                {page}
                            </button>
                        ))}
                        <button
                            className="pagination-btn"
                            onClick={() => handlePageChange('next')}
                            disabled={currentPage === totalPages}
                        >
                            Next &raquo;
                        </button>
                    </div>
                </div>
            </div>

            <div className={`side-form ${showForm ? 'show' : ''}`}>
                <h3>Location</h3>
                {selectedCheckIn && (
                    <div>
                        {selectedCheckIn.location && selectedCheckIn.location.latitude && selectedCheckIn.location.longitude && (
                            <MapContainer
                                center={[selectedCheckIn.location.latitude, selectedCheckIn.location.longitude]}
                                zoom={13}
                                style={{ height: '300px', width: '100%' }}
                            >
                                <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                                <Marker
                                    position={[selectedCheckIn.location.latitude, selectedCheckIn.location.longitude]}
                                    icon={new L.Icon({ iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png', iconSize: [25, 41], iconAnchor: [12, 41] })}
                                >
                                    <Popup>
                                        <strong>Location:</strong> {selectedCheckIn.location.raw}
                                    </Popup>
                                </Marker>
                            </MapContainer>
                        )}
                        <p><strong>Address:</strong> {selectedCheckIn.address}</p>
                        <p><strong>Latitude:</strong> {selectedCheckIn.location.latitude}</p>
                        <p><strong>Longitude:</strong> {selectedCheckIn.location.longitude}</p>
                    </div>
                )}
                <button className="btn-cancel" onClick={closeForm}>Close</button>
            </div>
        </div>
    );
};

export default GuardianCheckIn;
